import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';

// Interface for our data structure for better type safety
interface NtaSummary {
  ntaid: number;
  Status: number | string;
  diagnosis: string;
  icD10: string;
  ntaCondition: string;
  clinicalCategory: string;
  Points: number;
  proposedICD10: string;
  Potential: number;
  Risk: string | null;
  isInclude: boolean;
  coreID: number;
  description: string;
  officeID: number;
  organizationID: number;

}

@Component({
  selector: 'app-nta-Referral',
  templateUrl: './nta-Referral.component.html',
  styleUrls: ['./nta-Referral.component.scss']
})


export class NTAReferralComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ntaSummaryData: any = [] = [];
  summaryData: any = [] = [];
  currentNTA: any;
  @Input() transactionID: number = 0;
  processStageID: number = 0;

  documentList: any = [] = [];


  constructor(private taskService: SettingService, private dialog: MatDialog,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private loaderService: LoaderService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<NTAReferralComponent>,
    private viewDialogRef: MatDialogRef<any>) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  private allNtaData: NtaSummary[] = [];
  public filteredNtaData: NtaSummary[] = [];
  public activeFilter: string = 'all';

  // --- Getters for Dynamic Filter Counts ---
  get allCount(): number {
    return this.allNtaData.length;
  }
  get readyCount(): number {
    return this.allNtaData.filter(item => item.Status === 'Definite' && item.Points > 0).length;
  }
  get stepUpCount(): number {
    return this.allNtaData.filter(item => item.Status === 'Review').length;
  }
  get overCodingCount(): number {
    return this.allNtaData.filter(item => item.Risk && item.Risk.trim() !== '').length;
  }
  get allZeroCount(): number {
    return this.allNtaData.filter(item => (item.Status === 'Definite' && item.Points === 0) || (item.Status === 'Review' && item.Potential === 0)).length;
  }


  ngOnInit(): void {
    this.ntaSummaryData=[];
    this.filteredNtaData=[];
    const rawNtaData = sessionStorage.getItem('ntaSummaryJson');
    if (rawNtaData !== null) {
      let ntaData: any;
      if(rawNtaData == "null"){
        return;
      }
      ntaData = JSON.parse(rawNtaData);

      this.ntaSummaryData = ntaData.NtaSummary;      
      this.allNtaData = this.ntaSummaryData;
      this.setFilter('all'); // Set initial filter
      const summary = ntaData.Summary;

      if (summary) {
        this.summaryData = [
          { title: 'NTA Points', value: summary.Points ?? summary.NtaPoints ?? 'NA' },
          { title: 'NTA CMG', value: summary.NtaCmg ?? 'NA' },
          { title: 'HIPPS Character', value: summary.HippsCharacter ?? 'NA' },
          { title: 'NTA CMI', value: summary.NtaCmi ?? 'NA' },
          { title: 'Step-Up Potential', value: summary.StepUpPotential ?? 'NA' },
          { title: 'Over-Coding Risk', value: summary.OverCodingRisk ?? 'NA' },
          { title: 'Optimization Score', value: summary.OptimizationScore != null ? summary.OptimizationScore + '%' : '0%' }
        ];
      } else {
        this.summaryData = [
          { title: 'NTA Points', value: 'NA' },
          { title: 'NTA CMG', value: 'NA' },
          { title: 'HIPPS Character', value: 'NA' },
          { title: 'NTA CMI', value: 'NA' },
          { title: 'Step-Up Potential', value: 'NA' },
          { title: 'Over-Coding Risk', value: 'NA' },
          { title: 'Optimization Score', value: '0%' }
        ];
      }
      return;
    }
  }


  public setFilter(filter: string): void {
    this.activeFilter = filter;
    switch (filter) {
      case 'ready':
        this.filteredNtaData = this.allNtaData.filter(item => item.Status === 'Definite' && item.Points > 0);
        break;
      case 'stepUp':
        this.filteredNtaData = this.allNtaData.filter(item => item.Status === 'Review');
        break;
      case 'overCoding':
        this.filteredNtaData = this.allNtaData.filter(item => item.Risk && item.Risk.trim() !== '');
        break;
      case 'allZero':
        this.filteredNtaData = this.allNtaData.filter(item => (item.Status === 'Definite' && item.Points === 0) || (item.Status === 'Review' && item.Potential === 0));
        break;
      case 'all':
      default:
        this.filteredNtaData = [...this.allNtaData].sort((a, b) => {
          const getPriority = (item: any): number => {
            if (item.Status === 'Definite' && item.Points > 0) return 1;
            if (item.Status === 'Review' && item.Points > 0) return 2;
            if (item.Status === 'Definite' && item.Points === 0) return 3;
            if (item.Status === 'Review' && item.Points === 0) return 4;
            return 5; // Other items
          };

          return getPriority(a) - getPriority(b);
        });
        break;
    }
  }


  close() {
    if (this.viewDialogRef) {
      this.viewDialogRef.close();
    }
  }

  viewNTADetails(templateRef: TemplateRef<any>, nta: any) {
    this.currentNTA = nta;
    this.viewDialogRef = this.dialog.open(templateRef);
    this.viewDialogRef.afterClosed().subscribe(() => {
      this.viewDialogRef = null;
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }

}
